import { gql } from "@apollo/client"
import { HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT } from "~/app/fragments/HiringFormEmploymentFields"
import { Mutation, MutationEmployerUpdateHireArgs } from "@oysterhr/schema"
import { InjectedOptions, useMutation } from "@oysterhr/core"

const UpdateHiringFormMutation = gql`
  mutation EmployerUpdateHire($input: EmployerUpdateHireInput!) {
    employerUpdateHire(input: $input) {
      employment {
        ...HiringFormEmploymentFields
      }
      errors
      fieldErrors {
        fieldId
        message
        target
      }
    }
  }
  ${HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT}
`

type UseUpdateHiringFormOptions = InjectedOptions<
  UseUpdateHiringFormReturnType,
  MutationEmployerUpdateHireArgs
>

export type UseUpdateHiringFormReturnType = { employerUpdateHire: Mutation["employerUpdateHire"] }

/**
 * I'm creating this new hook because there is gonna be some refactoring to stop using the updateEmployment mutation
 * on the hiring form, so instead of change the `useUpdateEmployment` hook that is being used everywhere,
 * we confine the changes to this specific hook
 */

type Options = UseUpdateHiringFormOptions

/**
 * Use this hook to update the data of the hiring form.
 * You can pass a setFormErrors function to this hook to update the errors of the form using BE validation
 */
export const useUpdateHiringForm = (options?: Options) => {
  return useMutation<UseUpdateHiringFormReturnType, MutationEmployerUpdateHireArgs>(
    UpdateHiringFormMutation,
    options,
  )
}
